// @flow
import * as React from 'react';
import {
  usePropsValidation,
  types as t,
} from '../../validation/runtime-checks/index.js';
import type { CompilerInjectedProps } from '../../validation/runtime-checks/index.js';
import { InternalBunnyVideo } from '../../InternalBunnyVideo.js';
import { useValidateBunnyVideoInLibrary } from '../../useValidateBunnyVideoInLibrary.js';

export function RSLBunnyVideo(props: {|
  videoId: string, // eg '5e7aee5a-5c7d-41d7-af17-ac58bcd4f3a6'
  ...CompilerInjectedProps,
|}) {
  const { failedValidation, addErrors, locations } = usePropsValidation(
    props,
    RSLBunnyVideo,
  );

  useValidateBunnyVideoInLibrary({
    performValidation: props._performValidation,
    failedValidation,
    addErrors,
    location: locations.videoId,
    videoId: props.videoId,
  });

  // Our aspect ratios are all over the shop (278 distinct aspect ratios 😱)
  // The most frequent aspect ratio (at time of writing) is 4:3.
  // See here for some analysis:
  // https://paper.dropbox.com/doc/Wistia-Video-Aspect-Ratio-Determination--BhWNRojL805v05axiESTRSoMAg-T0kXoXIM3zvIuBEPoHrLv
  const aspectRatio = 4 / 3;
  const width = 596;
  const height = width / aspectRatio; // 447
  const borderRadius = 8;

  if (failedValidation) return null;

  return (
    <div
      style={{
        position: 'relative',
        boxShadow: '0px 8.75px 49px rgba(62, 62, 76, 0.4)',
        borderRadius,
        overflow: 'hidden',
        // Ensure we shrink-wrap to the dimensions of the WistiaEmbed
        display: 'inline-block',
        margin: '32px 0',
      }}
    >
      <InternalBunnyVideo
        videoId={props.videoId}
        width={width}
        height={height}
        borderRadius={borderRadius}
      />
    </div>
  );
}
RSLBunnyVideo.spec = {
  videoId: t.string,
};
